import React, { useCallback, useContext, useState } from 'react';

import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { TranslationContext } from "./hooks/useTranslationContext";
import { ApiConnectionContext } from "./hooks/useApiConnectionContext";

export const LoginComponent = () => {

    const [ error, setError ] = useState(false);
    const [ username, setUsername ] = useState('');
    const [ password, setPassword ] = useState('');
    const [ loginWithTimeout, setLoginWithTimeout ] = useState(false);
    const [ showPassword, setShowPassword ] = useState(false);
    const { p, version, lanAddress } = useContext(ApiConnectionContext);

    const t = useContext(TranslationContext);

    const handleSubmit = useCallback((ev) => {
        ev.preventDefault();

        p.auth(username, password, loginWithTimeout).then(function () {
            setError(null);

        }, function (error) {
            const details = 
                t(error ? [ "login." + error.message, "login.invalid_credentials"] : "login.invalid_credentials");
            const errorMsg = t("login.error__", {error: details});
            // Login failed, shnow error
            setError(errorMsg);
        });
    }, [ username, password, loginWithTimeout, t, setError ]);

    const changeUseTimeout = useCallback((e) => {
        setLoginWithTimeout(e.target.checked);
    }, [ setLoginWithTimeout ]);

    let loginUrl = null;
    if (window.location.hostname.indexOf("10.190.16.") === 0
      || window.location.hostname.indexOf("10.190.17.") === 0
      || window.location.hostname.indexOf("10.190.18.") === 0
      || window.location.hostname.indexOf("gate.om7sense.com") === 0
      || window.location.hostname.indexOf("gate.pduexperts.com") === 0 ) {
        if (lanAddress) {
            loginUrl = window.location.protocol + "//" + lanAddress;
        } else {
            loginUrl = t('general.no_network');
        }
    }

    const formErrClass = "input-group" + ( error ? " has-error" : "");

    return (
        <div className="content columns col-gapless">
            <div className="column col-4">
                { loginUrl != null && (
                    <div>
                        <p className="login-description">
                            {t('login.headline')}
                        </p>
                        <h3>{ t('theme:product') } Network Address</h3>
                        <div className="login-address">
                            <a href={ loginUrl } target="_omsense">{ loginUrl }</a>
                        </div>
                    </div>
                )}
            </div>
            <div className="column col-4 login">
                <form onSubmit={ handleSubmit }>
                    <div className={`loginlogo ${t('style.logo_class')}`}></div>
                    <h1>{ t('theme:product') } { version ? version : "" } Login</h1>
                    <p>{ t("login.description") }</p>
                    <div className="input-group">
                        <span className="input-group-addon">{ t('login.username') }</span>
                        <input name="username" type="text" className="form-input" value={ username } onChange={ (e) => setUsername(e.target.value) } autoComplete="username" />
                    </div>
                    <div className={formErrClass}>
                        <span className="input-group-addon">{t(
                            'login.password')}</span>
                        <input
                            type={showPassword ? "text" : "password"}
                            name="password"
                            className="form-input"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            autoComplete="current-password"/>
                        <button
                            type="button"
                            className={`btn input-group-btn ${showPassword || 'btn-primary'}`}
                            onClick={() => {
                                setShowPassword(!showPassword); return false
                            }}
                        >
                            <FontAwesomeIcon icon={icon({name: 'eye', family: 'sharp', style: 'solid'})} />
                        </button>
                    </div>
                    {error && (
                        <p className="loginerror">{ error }</p>
                    )}
                    <div className="input-group">
                        <label className="form-checkbox">
                            <input type="checkbox" checked={ loginWithTimeout } onChange={changeUseTimeout} />
                            <i className="form-icon"></i> { t('login.logout_automatically') }
                        </label>
                    </div>
                    <input type="submit" className="btn btn-primary btn-block" value={t('login.button_login')}/>
                </form>

            </div>
            <div className="column col-4">

            </div>
        </div>
    );
}



